<script setup lang="ts">
import type { DistributionGroup } from '@forgd/contract/types'
import type { DistributionGroupByType } from './DtDistributionPreview.vue'
import DtDistributionPreview from '#design-tokenomics/components/DtDistributionPreview.vue'
import { Card, CardContent, CardHeader, CardTitle } from '@forgd/ui-kit/card'
import { ToggleGroup, ToggleGroupItem } from '@forgd/ui-kit/toggle-group'

const props = defineProps<{ groups: Array<DistributionGroup>, totalAllocation: number }>()

const groupByType = ref<DistributionGroupByType>('group')
</script>

<template>
  <Card variant="neutral">
    <CardHeader>
      <CardTitle class="text-sm/normal">
        Distribution Preview
      </CardTitle>
      <slot name="header-action" />
    </CardHeader>

    <CardContent class="flex flex-col gap-5">
      <ToggleGroup
        v-model="groupByType"
        preset="dark"
        size="md"
        layout="fill"
      >
        <ToggleGroupItem value="group">
          By Group
        </ToggleGroupItem>
        <ToggleGroupItem value="category">
          By Category
        </ToggleGroupItem>
        <ToggleGroupItem value="int-ext">
          Int. Vs. Ext.
        </ToggleGroupItem>
      </ToggleGroup>
      <DtDistributionPreview
        v-if="groups"
        :groups="props.groups"
        :total-allocation="props.totalAllocation"
        :group-by="groupByType"
      />
    </CardContent>
  </Card>
</template>
